<mat-form-field *ngIf="control && filteredData" fxFlex="100">
  <mat-label>{{label | translate}}</mat-label>
  <mat-select [formControl]="control" #lovSelect [required]="isRequired" [compareWith]="compareFn"
    (selectionChange)="onSelectionChange($event)" (openedChange)="openEvent($event)">
    <input class="mat-input-element search-field" #searchElement type="text" (input)="search($event.target.value)"
      (keyup.enter)="selectFirst()" (keydown)="$event.stopPropagation()" placeholder="{{ 'search' | translate }}">
    <mat-option *ngIf="!isRequired" [value]="null">{{noneLabel ? noneLabel : ('none' | translate)}}</mat-option>
    <mat-option *ngFor="let option of filteredData" [value]="option">
      {{option.lovLabel ? option.lovLabel : option.rid}}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hint">{{hint|translate}}</mat-hint>
  <mat-error>{{getErrorMessage(form.get(controlName))}}</mat-error>
</mat-form-field>